export const UndoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0)'>
        <mask
          id='mask0'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='2'
          y='1'
          width='20'
          height='21'
        >
          <rect x='2' y='1.69922' width='20' height='20' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0)'>
          <path
            d='M12.0001 19.4063C11.0866 19.4063 10.2307 19.2336 9.43237 18.8882C8.63404 18.5428 7.93793 18.073 7.34404 17.479C6.75001 16.8851 6.28029 16.189 5.93487 15.3907C5.58946 14.5923 5.41675 13.7364 5.41675 12.823H6.50008C6.50008 14.3369 7.03828 15.632 8.11466 16.7084C9.19105 17.7848 10.4862 18.323 12.0001 18.323C13.514 18.323 14.8091 17.7848 15.8855 16.7084C16.9619 15.632 17.5001 14.3369 17.5001 12.823C17.5001 11.3091 16.9619 10.0139 15.8855 8.93755C14.8091 7.86116 13.5113 7.32297 11.992 7.32297H11.7788L12.8734 8.41755L12.0995 9.17547L9.70529 6.77339L12.1155 4.37109L12.8895 5.12901L11.758 6.23964H12.0001C12.9136 6.23964 13.7695 6.41234 14.5678 6.75776C15.3661 7.10318 16.0622 7.5729 16.6561 8.16693C17.2502 8.76082 17.7199 9.45693 18.0653 10.2553C18.4107 11.0536 18.5834 11.9095 18.5834 12.823C18.5834 13.7364 18.4107 14.5923 18.0653 15.3907C17.7199 16.189 17.2502 16.8851 16.6561 17.479C16.0622 18.073 15.3661 18.5428 14.5678 18.8882C13.7695 19.2336 12.9136 19.4063 12.0001 19.4063Z'
            fill='currentColor'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
